import { Availability } from './components/requests/Availability';
import { Cover } from './components/requests/Cover';
import { CoverDetails } from './components/requests/Cover/CoverDetails';
import { OpenShift } from './components/requests/OpenShift';
import { OpenShiftDetails } from './components/requests/OpenShift/OpenShiftDetails';
import { TimeOff } from './components/requests/TimeOff';
import { TimeOffDetail } from './components/requests/TimeOff/TimeOffDetail';
import { Trade } from './components/requests/Trade';
import { TradeDetails } from './components/requests/Trade/TradeDetails';
import {
  Availability as AvailabilityType,
  RequestType,
  TimeOff as TimeOffType,
  TradeCoverClaim as TradeCoverClaimType,
} from './types';

export const VIEWS = {
  availability: (item: AvailabilityType) => <Availability request={item} />,
  time_off: (
    item: TimeOffType,
    setSelectedRequest: (request: TimeOffType, type: RequestType) => void
  ) => <TimeOff request={item} setSelectedRequest={setSelectedRequest} />,
  claim: (
    item: TradeCoverClaimType,
    setSelectedRequest: (
      request: TradeCoverClaimType,
      type: RequestType
    ) => void
  ) => <OpenShift request={item} setSelectedRequest={setSelectedRequest} />,
  cover: (
    item: TradeCoverClaimType,
    setSelectedRequest: (
      request: TradeCoverClaimType,
      type: RequestType
    ) => void
  ) => <Cover request={item} setSelectedRequest={setSelectedRequest} />,
  trade: (
    item: TradeCoverClaimType,
    setSelectedRequest: (
      request: TradeCoverClaimType,
      type: RequestType
    ) => void
  ) => <Trade request={item} setSelectedRequest={setSelectedRequest} />,
};

export const DETAIL_VIEWS = {
  time_off: (
    requestId: string,
    onClose: () => void,
    isTeamRequest?: boolean,
    responderName?: string
  ) => (
    <TimeOffDetail
      requestId={requestId}
      isTeamRequest={isTeamRequest}
      responderName={responderName}
      onClose={onClose}
    />
  ),
  claim: (requestId: string, onClose: () => void) => (
    <OpenShiftDetails requestId={requestId} onClose={onClose} />
  ),
  trade: (requestId: string, onClose: () => void, isTeamRequest?: boolean) => (
    <TradeDetails
      isTeamRequest={isTeamRequest}
      requestId={requestId}
      onClose={onClose}
    />
  ),
  cover: (requestId: string, onClose: () => void, isTeamRequest?: boolean) => (
    <CoverDetails
      requestId={requestId}
      isTeamRequest={isTeamRequest}
      onClose={onClose}
    />
  ),
};
